import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, Row, Col, Label, Input, Button, Spinner } from "reactstrap";
import { toast } from "react-toastify";
import { sendTestMailApi } from "../../apiServices/emailLogServices";

const SendTestMailModal = ({ isOpen, toggle, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    recipient: "",
    subject: "RS-CRM SMTP Mailer Test Message",
    category: "Test Mail",
    htmlBody: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.recipient || !formData.subject) {
      toast.error("Please enter recipient email and subject");
      return;
    }

    try {
      setLoading(true);
      await sendTestMailApi(formData);
      toast.success(`Test email sent successfully to ${formData.recipient}!`);
      toggle();
      if (onSuccess) onSuccess();
      setFormData({
        recipient: "",
        subject: "RS-CRM SMTP Mailer Test Message",
        category: "Test Mail",
        htmlBody: "",
      });
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to send test mail via SMTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle}>
        <i className="mdi mdi-email-send-outline me-1 text-primary"></i> Send SMTP Test Email
      </ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <Row>
            <Col md={12} className="mb-3">
              <Label className="form-label">
                Recipient Email <span className="text-danger">*</span>
              </Label>
              <Input
                type="email"
                name="recipient"
                value={formData.recipient}
                onChange={handleChange}
                placeholder="e.g. client@example.com or admin@domain.com"
                required
              />
            </Col>
            <Col md={6} className="mb-3">
              <Label className="form-label">
                Subject Line <span className="text-danger">*</span>
              </Label>
              <Input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="Email Subject"
                required
              />
            </Col>
            <Col md={6} className="mb-3">
              <Label className="form-label">Email Category</Label>
              <Input
                type="select"
                name="category"
                value={formData.category}
                onChange={handleChange}
              >
                <option value="Test Mail">Test Mail</option>
                <option value="Custom Mail">Custom Mail</option>
                <option value="Lead Notification">Lead Notification</option>
                <option value="Bill Invoice">Bill Invoice</option>
                <option value="OTP">OTP</option>
              </Input>
            </Col>
            <Col md={12} className="mb-3">
              <Label className="form-label">Custom HTML Body (Optional)</Label>
              <Input
                type="textarea"
                rows="5"
                name="htmlBody"
                value={formData.htmlBody}
                onChange={handleChange}
                placeholder="Leave blank for default styled HTML template or enter custom <html> content..."
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="secondary" onClick={toggle} disabled={loading}>
            Cancel
          </Button>
          <Button type="submit" color="primary" disabled={loading}>
            {loading ? <Spinner size="sm" /> : <><i className="mdi mdi-send me-1"></i> Send Test Mail</>}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default SendTestMailModal;
